export const GMAIL_TO = 'marwa.hawshar.h@gmail.com';
export const GMAIL_COMPOSE_URL = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(GMAIL_TO)}`;

export const PHONE_NUMBER = '+9613313264';
export const PHONE_DISPLAY = '+961 3 313 264';
export const PHONE_TEL_URL = `tel:${PHONE_NUMBER}`;

export const WHATSAPP_NUMBER = '9613313264';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export const GOOGLE_MAPS_URL = 'https://www.google.com/maps?q=Al%20Nejmeh%20Square%2C%20Tripoli%2C%20Lebanon';
